/**
 *
 * ModalRecommendationCreate
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Modal, Button, Input, TreeSelect, Spin } from "antd"
import { Form } from "@ant-design/compatible"
import {
  getUtilsRecommendationApi,
  saveRecommendationApi,
} from "services/actionPlans"
import { addLevel, generateTree } from "utils/utils"
import { flatMap, orderBy } from "lodash"
import Fade from "react-reveal/Fade"
import alertSvg from "images/alert.svg"
import ButtonsFooter from "../ButtonsFooter"
import ListTree from "../ListTree"
import RecommendationTaskForm from "../RecommendationTaskForm"
import ModalDeleteSimple from "../ModalDeleteSimple"
import Select from "../Select"
import ModalCustom from "../ModalCustom"
import RecommendationTaskResumen from "../RecommendationTaskResumen"
import "@ant-design/compatible/assets/index.css"
import "./index.less"
import { buttonAction_btns } from "../Snowplow/config2"

const { TreeNode } = TreeSelect
const FormItem = Form.Item

const recursiveFindChildsId = (array = [], data) => {
  array.push(data.id_dimension)
  if (data.childs && data.childs.length > 0) {
    data.childs.map((e) => recursiveFindChildsId(array, e))
  }
  return array
}
/* eslint-disable react/prefer-stateless-function */
class ModalRecommendationCreate extends React.Component {
  is_new = true
  state = {
    loadingEditable: false,
    modal: false,
    modalDimensions: false,
    modalCancel: false,
    view: false,
    models: [],
    divisions: [],
    dimensions: [],
    ambassadors: [],
    selectedDimension: [],
    selectedModel: null,
    loadingModels: true,
    openDimensions: [],
    name: "",
    description: "",
    loadingSave: false,
    secondStep: false,
    taskCreate: false,
    tasks: [],
    actionPlanEditInfo: {},
    currentTask: {},
    currentTaskIndex: null,
    modalDeleteTaks: false,
    loadingDimensions: false,
  }

  componentDidUpdate() {
    if (this.state.view) {
      document.querySelector("body").classList.add("openViewCreatePlanAction")
    } else {
      document
        .querySelector("body")
        .classList.remove("openViewCreatePlanAction")
    }
  }

  componentDidMount() {
    const { visible } = this.props
    if (visible) {
      this.setState({ modal: true })
    }
    this.loadBasicData({ initial: true })
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.props.visible != props.visible && props.visible) {
      const isEdit = !!props.modalRecommendationEditId
      this.is_new = !isEdit
      this.setState({ modal: true, view: isEdit, actionPlanEditInfo: {} })
      if (isEdit) {
        this.loadEditDetails(props.modalRecommendationEditId)
      }

      if (props.initialData) {
        // Call when set data for default
        const validMeditionAndDivision =
          props.initialData.measure && props.initialData.division
        this.setState(
          {
            modal: !validMeditionAndDivision,
            modalDimensions: validMeditionAndDivision,
            loadingModels: validMeditionAndDivision,
            selectedModel: props.initialData.measure || null,
            selectedDimension: props.initialData.dimensions || [],
          },
          async () => {
            if (validMeditionAndDivision) {
              await this.loadDimensions(true)
            } else {
              await this.loadBasicData({ model: this.state.selectedModel })
            }
          }
        )
      }
    }
  }

  loadEditDetails = async (id) => {
    this.setState({ loadingEditable: true })
    try {
      const result = await fetchGlobalApi({
        method: "GET",
        endpoint: `recommendations/${id}/edit/`,
      })
      const { data } = result
      this.setState(
        {
          selectedDimension: flatMap(
            data.data.result.dimensions,
            (item) => item.dimension_name
          ),
          selectedModel: data.data.result.id_survey,
          name: data.data.result.name,
          description: data.data.result.description,
          actionPlanEditInfo: data.data.result,
          tasks: data.data.result.tasks,
        },
        async () => {
          await this.loadDimensions(false)
        }
      )
    } catch (error) {}
  }

  /**
   * Carga lo necesario para iniciar a crear un recomendación
   * Recibe un objeto, el cuál será usado para enviar según sea el selector: medición, división
   */
  loadBasicData = async (obj = {}) => {
    try {
      const result = await getUtilsRecommendationApi({ id_survey: obj.model })
      const { data } = result.data
      if (obj.initial) {
        this.props.canCreate(data.result.surveys.length > 0)
        this.props.setMeasures(data.result.surveys)
      }
      this.setState(
        {
          models: data.result.surveys,
          loadingModels: false,
        },
        () => {}
      )
    } catch (error) {}
  }

  loadDimensions = async (secondStep) => {
    this.setState({
      loadingDimensions: true,
      loadingAmbassadors: true,
      ambassadors: [],
    })
    try {
      const dimensions = await getUtilsRecommendationApi({
        id_survey: this.state.selectedModel,
      })
      const dimensions_data = dimensions.data.data.result.dimensions
      let result = generateTree("id_dimension", "id_dimension_parent", [
        ...JSON.parse(JSON.stringify(dimensions_data)),
      ])
      result.forEach(addLevel(1))
      result = orderBy(result, "percent", "asc")
      this.setState(
        {
          dimensions: result,
          loadingDimensions: false,
          modal: false,
          modalDimensions: true,
          view: !secondStep,
          loadingEditable: false,
        },
        () => {
          setTimeout(() => {
            overflowTreeSelect(".dimension-action-plan-create-modal")
          }, 1000)
        }
      )
    } catch (error) {
      this.setState({ loadingDimensions: false })
    }
  }

  cancelModal = () => {
    this.setState(
      {
        modal: false,
        modalDimensions: false,
        modalCancel: false,
        view: false,
      },
      () => {
        // Pondremos un setTimeOut para no mostrar cambios en la vista hasta que se oculte el modal.
        setTimeout(() => {
          this.setState(
            {
              selectedDivision: null,
              selectedDimension: [],
              selectedModel: null,
              divisions: [],
              ambassadors: [],
              loadingSave: false,
              name: "",
              description: "",
              openDimensions: [],
              taskCreate: false,
              tasks: [],
            },
            () => {
              this.props.onCancel({})
            }
          )
        }, 250)
      }
    )
  }

  backModalDimension = () => {
    this.setState({
      modal: true,
      modalDimensions: false,
    })
  }

  clickDimension = (item) => {
    const { openDimensions } = this.state
    const index = openDimensions.findIndex((e) => e === item.id_dimension)
    if (index > -1) {
      openDimensions.splice(index, 1)
      const indexChilds = recursiveFindChildsId([], item)
      indexChilds.map((iC) => {
        const indexChild = openDimensions.findIndex((e) => e === iC)
        if (indexChild > -1) {
          openDimensions.splice(indexChild, 1)
        }
      })
    } else {
      openDimensions.push(item.id_dimension)
    }
    this.setState({ openDimensions })
  }

  selectDimension = (item) => {
    const { selectedDimension } = this.state
    const index = selectedDimension.findIndex((e) => e === item)
    if (index > -1) {
      selectedDimension.splice(index, 1)
    } else {
      selectedDimension.push(item)
    }
    this.setState({ selectedDimension })
  }

  handleOk = () => {
    buttonAction_btns("Crear - Agregar recomendacion")
    this.setState({
      modalDimensions: false,
      view: true,
    })
  }

  addTask = (params) => {
    const { tasks } = this.state
    tasks.push(params)
    this.setState({ tasks, taskCreate: false })
  }

  editTask = (params, index) => {
    const { tasks } = this.state
    tasks[index] = params
    this.setState({ tasks, taskCreate: false })
  }

  saveActionPlan = async () => {
    const {
      name,
      description,
      selectedDimension,
      selectedModel,
      actionPlanEditInfo,
      tasks,
    } = this.state
    this.setState({ loadingSave: true })
    try {
      const object = {
        id: actionPlanEditInfo.id_recommendation || null,
        name,
        description,
        // archived: actionPlanEditInfo.archived || 0,
        // history: 0,
        // status: actionPlanEditInfo.status || 1,
        id_survey: selectedModel,
        dimensions: flatMap(selectedDimension, (item) => {
          return { dimension_name: item }
        }),
      }
      if (tasks.length > 0) {
        object.tasks = tasks
      }
      const save = await saveRecommendationApi(object)
      this.cancelModal()
      this.props.finish({})
      returnMessage(save)
    } catch (error) {
      this.setState({ loadingSave: false })
      returnMessage(error)
    }
  }

  renderSelectModels = () => {
    const { selectedModel, loadingModels, models } = this.state
    return (
      <Fragment>
        <p>
          Selecciona el <b>modelo</b> para el que deseas crear la recomendación:
        </p>
        <Select
          onChange={(selectedModel) => {
            this.setState({
              selectedModel: selectedModel.id_survey,
              selectedDivision: null,
            })
          }}
          options={models}
          labelKey="id_survey"
          label="name"
          style={{ width: 300, marginBottom: 10 }}
          value={selectedModel || null}
          placeholder="Seleccionar modelo"
          isLoading={loadingModels}
        />
      </Fragment>
    )
  }

  firstModal = () => {
    return <Fragment>{this.renderSelectModels()}</Fragment>
  }

  render() {
    const {
      modal,
      modalDimensions,
      dimensions,
      loadingModels,
      openDimensions,
      selectedModel,
      selectedDimension,
      view,
      name,
      description,
      loadingSave,
      secondStep,
      taskCreate,
      tasks,
      loadingEditable,
      currentTask,
      currentTaskIndex,
      modalDeleteTaks,
      loadingDimensions,
      modalCancel,
    } = this.state
    const {
      form: { getFieldDecorator, resetFields, validateFieldsAndScroll },
      modalRecommendationEditId,
    } = this.props
    return (
      <Fragment>
        <Modal
          width={500}
          visible={modal && !modalRecommendationEditId}
          title="Agregar recomendación"
          closable={false}
          width={520}
          footer={
            <div>
              <Button key="backInit" onClick={this.cancelModal}>
                Cancelar
              </Button>
              <Button
                loading={loadingDimensions}
                disabled={!selectedModel}
                key="submitInit"
                type="primary"
                onClick={() => this.loadDimensions(true)}>
                Seleccionar
              </Button>
            </div>
          }
          bodyStyle={{ fontSize: 13 }}>
          {this.firstModal()}
        </Modal>

        <Modal
          width={500}
          visible={modalDimensions && !modalRecommendationEditId}
          title="Agregar recomendación"
          closable={false}
          footer={
            <div style={{ display: "flex" }}>
              <Button
                key="previus"
                onClick={this.backModalDimension}
                style={{ marginRight: "auto" }}>
                &lt; Anterior
              </Button>
              <Button key="back" onClick={this.cancelModal}>
                Cancelar
              </Button>
              <Button
                key="submit"
                type="primary"
                loading={loadingModels}
                onClick={this.handleOk}>
                Crear
              </Button>
            </div>
          }
          bodyStyle={{ fontSize: 13 }}>
          <p>
            Selecciona las <b>dimensiones</b> que buscarás mejorar con la
            recomendación:
          </p>
          <div className="ModalRecommendationCreate-component-dimensions">
            <ListTree
              showCheckbox
              hideHeaders={[]}
              isLoading={loadingModels}
              openDimensions={openDimensions}
              data={dimensions}
              selectedDimension={selectedDimension}
              valueChecked="dimension_name"
              clickDimension={(e) => this.clickDimension(e)}
              onSelectDimension={(d) => this.selectDimension(d.dimension_name)}
            />
          </div>
        </Modal>

        <Fade duration={300} when={view}>
          {view && (
            <div
              className="ModalRecommendationCreate-component-view buttonsFooter"
              style={{
                marginTop: 0,
                height: "calc(100% - 53px)",
                overflow: "auto",
                ...this.props.stylePdaLast,
              }}>
              {loadingEditable ? (
                <div className="loadingSpin">
                  <Spin size="large" />
                </div>
              ) : (
                <Fragment>
                  <div className="ModalRecommendationCreate-component-view-header">
                    <h4 className="ModalRecommendationCreate-component-view-header-title title_section">
                      {this.is_new ? "Agregar" : "Editar"} recomendación
                    </h4>
                  </div>
                  <div className="ModalRecommendationCreate-component-view-content">
                    <div className="ModalRecommendationCreate-component-view-content-columns">
                      <div className="ModalRecommendationCreate-component-view-content-columns-left">
                        <div
                          className="ModalRecommendationCreate-component-view-content-columns-left-block"
                          style={{ gridTemplateColumns: "1.5fr 1fr" }}>
                          <div>
                            <div>La recomendación ayudará a mejorar*</div>
                            <div>
                              <FormItem>
                                {getFieldDecorator("selectedDimension", {
                                  initialValue: selectedDimension,
                                  rules: [
                                    {
                                      required: true,
                                      message: formLabelMessage(
                                        "es",
                                        "required"
                                      ),
                                    },
                                  ],
                                })(
                                  <TreeSelect
                                    placeholder="Seleccionar dimensiones"
                                    style={{ width: "100%" }}
                                    dropdownStyle={{ maxHeight: 250 }}
                                    showSearch
                                    multiple
                                    allowClear
                                    treeDefaultExpandAll
                                    treeNodeFilterProp="title"
                                    className="dimension-action-plan-create-modal"
                                    onChange={(s, c, extra) => {
                                      this.setState(
                                        { selectedDimension: c },
                                        () => {
                                          overflowTreeSelect(
                                            ".dimension-action-plan-create-modal"
                                          )
                                        }
                                      )
                                    }}>
                                    {dimensions.map((e, keyDimension) => {
                                      return (
                                        <TreeNode
                                          idSelected={e.dimension_name}
                                          value={e.dimension_name}
                                          title={e.dimension_name}
                                          key={`${e.id_dimension}-${keyDimension}`}>
                                          {e.childs &&
                                            e.childs.map((child, childKey) => {
                                              return (
                                                <TreeNode
                                                  value={child.dimension_name}
                                                  title={child.dimension_name}
                                                  disabled
                                                  key={`${child.id_dimension}-${e.id_dimension}-${childKey}`}
                                                  idSelected={
                                                    child.dimension_name
                                                  }
                                                />
                                              )
                                            })}
                                        </TreeNode>
                                      )
                                    })}
                                  </TreeSelect>
                                )}
                              </FormItem>
                            </div>
                          </div>
                        </div>
                        <div className="ModalRecommendationCreate-component-view-content-columns-left-block">
                          <div>
                            <div>
                              Ingresa el <b>título</b> de la recomendación*
                            </div>
                            <div>
                              <FormItem>
                                {getFieldDecorator("name", {
                                  initialValue: name,
                                  rules: [
                                    {
                                      required: true,
                                      message: formLabelMessage(
                                        "es",
                                        "required"
                                      ),
                                    },
                                  ],
                                })(
                                  <Input
                                    maxLength={200}
                                    placeholder="Ingresa un título breve. Luego detállalo en la descripción..."
                                    onChange={(e) =>
                                      this.setState({ name: e.target.value })
                                    }
                                  />
                                )}
                              </FormItem>
                            </div>
                          </div>
                        </div>
                        <div className="ModalRecommendationCreate-component-view-content-columns-left-block">
                          <div>
                            <div>
                              Ingresa la descripción de la recomendación
                            </div>
                            <div>
                              <FormItem>
                                {getFieldDecorator("description", {
                                  initialValue: description,
                                })(
                                  <Input.TextArea
                                    maxLength={350}
                                    placeholder="Escribe aquí la descripción..."
                                    autoSize={{ minRows: 2, maxRows: 4 }}
                                    onChange={(e) =>
                                      this.setState({
                                        description: e.target.value,
                                      })
                                    }
                                  />
                                )}
                              </FormItem>
                            </div>
                          </div>
                        </div>
                        <div
                          className="ModalRecommendationCreate-component-view-content-columns-left-block"
                          style={{ gridGap: 15 }}>
                          <div className="ModalRecommendationCreate-component-view-content-columns-left-block-header">
                            <span>Tareas</span>
                          </div>
                          {!taskCreate && tasks.length === 0 && (
                            <Fragment>
                              <p style={{ margin: 0 }}>
                                Debes agregar al menos una tarea dentro de la
                                recomendación.
                              </p>
                            </Fragment>
                          )}
                          {!taskCreate && (
                            <div style={{ display: "block" }}>
                              <Button
                                type="primary"
                                onClick={() =>
                                  this.setState({ taskCreate: true })
                                }>
                                + Agregar tarea
                              </Button>
                            </div>
                          )}
                          {!taskCreate &&
                            tasks.map((t, ti) => (
                              <RecommendationTaskResumen
                                onEdit={(params) => {
                                  this.setState({
                                    taskCreate: true,
                                    currentTask: params,
                                    currentTaskIndex: ti,
                                  })
                                }}
                                onDelete={() =>
                                  this.setState({
                                    currentTaskIndex: ti,
                                    modalDeleteTaks: true,
                                  })
                                }
                                data={t}
                                key={`actionplan-task-${ti}`}
                              />
                            ))}
                        </div>
                        {taskCreate && (
                          <div>
                            <RecommendationTaskForm
                              data={{ ...currentTask }}
                              onFinishSave={(params) => {
                                if (currentTaskIndex != null) {
                                  this.editTask(params, currentTaskIndex)
                                } else {
                                  this.addTask(params)
                                }
                              }}
                              onCancel={() =>
                                this.setState({
                                  taskCreate: false,
                                  currentTask: {},
                                  currentTaskIndex: null,
                                })
                              }
                            />
                          </div>
                        )}
                      </div>
                      <div className="ModalRecommendationCreate-component-view-content-columns-right" />
                    </div>
                  </div>
                  <ButtonsFooter
                    buttons={[
                      {
                        content: "Cancelar",
                        onClick: () => {
                          this.setState({ modalCancel: true })
                        },
                        type: "",
                      },
                      {
                        disabled: !!(
                          selectedDimension.length === 0 ||
                          name.length === 0 ||
                          taskCreate
                        ),
                        content: this.is_new ? "Crear" : "Guardar",
                        onClick: () => {
                          validateFieldsAndScroll((err, values) => {
                            if (!err) {
                              this.saveActionPlan()
                            }
                          })
                        },
                        type: "primary",
                        loading: loadingSave,
                      },
                    ]}
                  />
                </Fragment>
              )}
            </div>
          )}
        </Fade>
        <ModalDeleteSimple
          visible={modalDeleteTaks}
          content={
            <Fragment>
              <p>¿Estás seguro de que desea eliminar la tarea?</p>
            </Fragment>
          }
          onOk={() => {
            const { tasks, currentTaskIndex } = this.state
            tasks.splice(currentTaskIndex, 1)
            this.setState({
              tasks,
              currentTaskIndex: null,
              modalDeleteTaks: false,
            })
          }}
          onCancel={() =>
            this.setState({
              modalDeleteTaks: false,
              currentTaskIndex: null,
            })
          }
        />
        <ModalCustom
          modalOpen={modalCancel}
          showFooter
          onOk={() => {
            resetFields()
            this.cancelModal()
          }}
          textCancelButton="Cancelar"
          onCancel={() => this.setState({ modalCancel: false })}>
          <img src={alertSvg} className="alertIcon" />
          <span style={{ fontWeight: 600, fontSize: 14 }}>
            ¿Estás seguro de que deseas salir?
          </span>
          {this.is_new ? (
            <p>
              Se borrará el contenido de la recomendación y deberá crearse
              nuevamente.
            </p>
          ) : (
            <p>Se perderán los cambios realizados hasta el momento.</p>
          )}
        </ModalCustom>
      </Fragment>
    )
  }
}

ModalRecommendationCreate.propTypes = {}
ModalRecommendationCreate.defaultProps = {
  canCreate: () => {},
  modalRecommendationEditId: null,
  finish: () => {},
  setMeasures: () => {},
  initialData: null,
}
export default Form.create({ name: "modal_create_plan_action" })(
  ModalRecommendationCreate
)
